// export const baseURL = 'http://165.22.13.250:3002/api';
// export const baseURL = 'https://dancebook.thewebtestlink.xyz/api';
export const baseURL = 'https://ajwamart.pk/api';
// export const imgUrl = 'http://165.22.13.250:3002';
// export const imgUrl = 'https://dancebook.thewebtestlink.xyz';
export const imgUrl = 'https://ajwamart.pk';
// export const imgUrl = 'https://e-medical.thewebtestlink.xyz';
